// @copyright  2006 - 2026 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'raw-material.page.title': 'Raw Materials',
    'raw-material.page.search_results': 'Search Results',
    'raw-material.page.create.title': 'Create New Raw Material',
    'raw-material.page.search.title': 'Find Raw Materials',
    'raw-material.page.edit.title': 'Edit Raw Material',
    'raw-material.page.all': 'All',

    'raw-material.button.cancel': 'Cancel',
    'raw-material.button.select': 'Select',
    'raw-material.button.find': 'Find Raw Materials',
    'raw-material.button.search': 'Apply',
    'raw-material.button.create': 'Save Raw Material',
    'raw-material.button.new': 'New Raw Material',
    'raw-material.button.save': 'Save Changes',
    'raw-material.button.delete': 'Permanently Delete',
    'raw-material.button.edit': 'Edit',
    'raw-material.button.restore': 'Restore',
    'raw-material.button.reset': 'Reset',

    'raw-material.placeholder.search': 'Search raw materials',

    'raw-material.link.create_first_raw_material': 'Click here to create your first raw material',
    'raw-material.link.raw_materials': ' Return to Raw Materials',
    'raw-material.link.retry': 'Click here to retry',

    'raw-material.checkbox.all': 'Check All',
    'raw-material.checkbox.actions_label': 'with selected',

    'raw-material.label.inventory_category_name': 'Category',
    'raw-material.label.inventory_manufacturer_name': 'Manufacturer',
    'raw-material.label.reporting_segment_name': 'Reporting Segment',
    'raw-material.label.inventory_type_name': 'Type',
    'raw-material.label.income_general_ledger_account_name': 'Income General Ledger Account',
    'raw-material.label.cost_of_good_sold_general_ledger_account_name': 'Cost Of Good Sold General Ledger Account',
    'raw-material.label.asset_general_ledger_account_name': 'Asset General Ledger Account',
    'raw-material.label.tax_name': 'Tax',
    'raw-material.label.item_number': 'Item Number',
    'raw-material.label.barcode': 'Barcode',
    'raw-material.label.item_name': 'Item',
    'raw-material.label.item_description': 'Item Description',
    'raw-material.label.currency_name': 'Currency',
    'raw-material.label.is_fixed_price': 'Is Fixed Price',
    'raw-material.label.units': 'unit|units',

    'raw-material.label.unit_of_measure': 'Unit of Measure',
    'raw-material.label.selling_price_in_cents': 'Unit Cost',
    'raw-material.label.reorder_level': 'Reorder Level',
    'raw-material.label.units_on_hand': 'Units On Hand',

    'raw-material.label.created_at': 'Created At',
    'raw-material.label.updated_at': 'Updated At',

    'raw-material.label.status': 'Status',

    'raw-material.sort.field_label': 'Field',
    'raw-material.sort.direction_label': 'Direction',
    'raw-material.sort.direction_ascending': 'Ascending',
    'raw-material.sort.direction_descending': 'Descending',

    'raw-material.modal.title.raw_material_delete_permanently': 'Delete Raw Material',
    'raw-material.modal.title.raw_material_restore': 'Restore Raw Material',

    'raw-material.modal.message.raw_material_delete_permanently':
        'Are you sure that you want to permanently delete this raw material? This action cannot be undone. | Are you sure that you want to permanently delete these raw materials? This action cannot be undone.',
    'raw-material.modal.message.raw_material_restore': 'Are you sure that you want to restore this raw material? | Are you sure that you want to restore these raw materials?',

    'raw-material.success.message.raw_material_created': 'Your raw material has been created',
    'raw-material.success.message.raw_material_updated': 'Your raw material has been updated',
    'raw-material.success.message.raw_material_restored': 'Your raw material has been restored | All selected raw materials were restored',

    'raw-material.error.message.raw_material_restored': 'This raw material was already restored | These raw materials were already restored',
    'raw-material.error.message.error_loading_page': 'Sorry, there was an error loading raw material.| Sorry, there was an error loading raw materials.',

    'raw-material.page.archive.title': 'Archived Raw Materials',
    'raw-material.button.archive': 'Archive',

    'raw-material.link.archive': 'Archived Raw Materials',

    'raw-material.modal.title.raw_material_archive': 'Archive Raw Material',

    'raw-material.modal.message.raw_material_archive': 'Are you sure that you want to move this raw material to the archive? | Are you sure that you want to move these raw materials to the archive?',

    'raw-material.success.message.archived_raw_materials': 'Your raw material was moved to the archive | All selected raw materials were moved to the archive',

    'raw-material.error.message.archived_raw_materials': 'This raw material was already moved to the archive | These raw materials were already moved to the archive',

    'raw-material.message.search.no_archived_raw_materials': "You don't have any archived raw materials.",
};
